<template>
    <div style="background-color: #fff;padding:16px 0 0px 16px; ">
        <el-row>
            <el-col :span="12">
                <title_value :title="$t('locateVehicle.acc_state')" :value="current.AccState" value-color="#0F1A3A" :width="90" />

            </el-col>
            <el-col :span="12">
                <title_value :title="$t('locateVehicle.speed')+'(km/h)'" :value="current.Speed" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value  :title="$t('locateVehicle.电量')+'(%)'" :value="current.SOC" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 1 || OilTypeID == 2">
                <title_value :title="$t('locateVehicle.engineRev')+'(rpm)'" :value="current.EngineSpped" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value :title="$t('locateVehicle.engineRev')+'(rpm)'" :value="current.MotorSpeed" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value :title="$t('locateVehicle.充电状态')" :value="current.ChargeState" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value :title="$t('locateVehicle.续航里程')+'(km)'" :value="current.DrivingRange" value-color="#0F1A3A" :width="90" />

            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value :title="$t('locateVehicle.总电压')+'(V)'" :value="current.TotalVoltage" value-color="#0F1A3A" :width="90" />

            </el-col>
            <el-col :span="12" v-if="OilTypeID == 5">
                <title_value :title="$t('locateVehicle.总电流')+'(A)'" :value="current.TotalElectric" value-color="#0F1A3A" :width="90" />

            </el-col>

            <el-col :span="12" v-if="OilTypeID == 1">
                <title_value :title="$t('locateVehicle.油量')+'(%)'" :value="current.OilPercent" value-color="#0F1A3A" :width="90" />
            </el-col>
            <el-col :span="12" v-if="OilTypeID == 1">
                <title_value :title="$t('locateVehicle.瞬时油耗')+'(l/h)'" :value="current.OilConsume" value-color="#0F1A3A" :width="90" /> 
            </el-col>

            <el-col :span="24">
                <title_value :title="$t('locateVehicle.运行总里程')+'(km)'" :value="current.Mileage" value-color="#0F1A3A" :width="120" />

            </el-col>

            <el-col :span="12">
                <title_value :title="$t('locateVehicle.更新时间')" :value="current.UpdateTime" value-color="#0F1A3A" :width="110" />
            </el-col>
            <el-col :span="12">
                <title_value :title="$t('locateVehicle.离线时间')" :value="current.OfflineDuration" value-color="#0F1A3A" :width="110" />
            </el-col>




            <el-col :span="24">
                <title_value   :title="$t('locateVehicle.direction')" :value="current.Direction" value-color="#0F1A3A" />
            </el-col>
            <!-- <el-col :span="24">
                <title_value title="线路" value="厦门北--高崎机场T4" value-color="#0F1A3A" />
            </el-col> -->
            <el-col :span="24">
                <title_value  :title="$t('locateVehicle.position')" :value="current.Position" value-color="#0F1A3A" />
            </el-col>
            <el-col   :span="24" v-if="false">
                <div style="display: flex;align-items: flex-start;margin-bottom: 16px;">
                    <div style="width: 88px;font-size: 14px;color: #0E193B;">{{$t('locateVehicle.胎压')}}</div>
                    <div
                        style="width: 300px; background: #F4F8FF;border-radius: 2px;padding:5px;font-size: 14px;font-weight: bold;height: 300px;text-align: center;">

                        <div
                            style="display: flex;align-items: center;justify-content: center;height: 100%; position: relative;">

                            <div class="car_info">
                            </div>
                            <!--左前-->
                            <div style="position: absolute;left: 20px;top: 82px;">
                                <div style="color: #FF106E;font-size: 14px;font-weight: bold;">2.2 bar</div>
                                <div style="border: 1px solid #FF106E;width: 88px;"></div>
                                <!-- <div style="color: #FF106E;font-size: 14px;font-weight: bold;">胎压不足</div> -->

                            </div>
                            <!--左后-->
                            <div style="position: absolute;left: 20px;top: 182px;">
                                <div style="color: #FF106E;font-size: 14px;font-weight: bold;">2.2 bar</div>
                                <div style="border: 1px solid #FF106E;width: 88px;"></div>
                                <!-- <div style="color: #FF106E;font-size: 14px;font-weight: bold;">胎压不足</div> -->

                            </div>

                            <!--右前-->
                            <div style="position: absolute;right: 20px;top: 82px;">
                                <div style="color: #0F1A3A;font-size: 14px;font-weight: bold;">2.4 bar</div>
                                <div style="border: 1px solid #0F1A3A;width: 88px;"></div>
                                <!-- <div style="color: #FF106E;font-size: 14px;font-weight: bold;">胎压不足</div> -->

                            </div>
                            <!--右后-->
                            <div style="position: absolute;right: 20px;top: 182px;">
                                <div style="color: #0F1A3A;font-size: 14px;font-weight: bold;">2.4 bar</div>
                                <div style=" border: 1px solid #0F1A3A;width: 88px;"></div>
                                <!-- <div style="color: #FF106E;font-size: 14px;font-weight: bold;">胎压不足</div> -->

                            </div>

                        </div>

                    </div>
                </div>
            </el-col>

        </el-row>

    </div>
</template>
<script>
import title_value from "./title_value"

export default {
    props: {
        OilTypeID: {
            type: Number,
            default: 5 ////外部传入 OilTypeID_New 1：柴油 2：气体机 3：油电 4：气电 5：纯电动
        },

        current: {
            type: Object,
            default: () => {
                return {
                    Position: "-",//最后位置
                    AccState: "-",//ACC状态
                    Speed: "-",//车速
                    SOC: "-",//SOC
                    Mileage: "-",//总里程
                    UpdateTime: "-",//更新时间
                    OfflineDuration: "-",//离线时间
                    DrivingRange: "-",//续航里程
                    OilPercent: "-",//剩余油量
                    TotalVoltage: "-",//总电压
                    TotalElectric: "-",//总电流
                    MotorSpeed: "-",//电机转速/发动机转速
                    ChargeState: "-",//充电状态           
                }
            }

        }

    },

    components: {
        title_value
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>
<style scoped>
.car_info {
    background-image: url("@/assets/images/pic_chetai@2x.png");
    height: 206px;
    width: 94px;
    background-repeat: no-repeat;
    background-size: contain;
}
</style>